var sachsenQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Freistaat Sachsen?',
    image: '421',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Sachsen?',
    answers: [
      {
        content: 'Vogtlandkreis',
        key: 1,
      },
      {
        content: 'Altötting',
        key: 0,
      },
      {
        content: 'Uckermark',
        key: 0,
      },
      {
        content: 'Nordfriesland',
        key: 0,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Sachsen gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Sachsen bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 0,
      },
      {
        content: '18',
        key: 1,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Sachsen?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'weiß-grün',
        key: 1,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
      {
        content: 'schwarz-gelb',
        key: 0,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Sachsen über politische Themen informieren?',
    answers: [
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Sachsen heißt...',
    answers: [
      {
        content: 'Leipzig.',
        key: 0,
      },
      {
        content: 'Dresden.',
        key: 1,
      },
      {
        content: 'Chemnitz.',
        key: 0,
      },
      {
        content: 'Zwickau.',
        key: 0,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Sachsen?',
    image: '428',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Sachsen?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Sachsen',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Sachsen nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Sachsen',
  },
]

export default sachsenQuestions
